
const digest = '1a948c25209261697142186695a42a83e9821df13f3c44366394874f7991100d';
const classes = {"rowTitle":"_rowTitle_171nh_1"};
const css = `._rowTitle_171nh_1 {
  align-items: flex-start;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  